var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizPartnership(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.401,
    height: 34.582,
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.086 -8.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(8.086 8.261)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.135 15.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.316 0.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.053 1.086)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.777459144592285 14.76771926879883 C 4.551269054412842 14.76771926879883 3.385519027709961 14.10737895965576 2.494969129562378 12.90834903717041 C 1.530929088592529 11.61035919189453 0.9999991655349731 9.841658592224121 0.9999991655349731 7.928049087524414 C 0.9999991655349731 5.912068843841553 1.096299171447754 3.850348949432373 1.794869184494019 2.42711877822876 C 2.230769157409668 1.539048910140991 3.117859125137329 0.3583988547325134 5.777459144592285 0.3583988547325134 C 8.43705940246582 0.3583988547325134 9.324149131774902 1.539048910140991 9.760048866271973 2.42711877822876 C 10.45861911773682 3.850348949432373 10.55491924285889 5.912068843841553 10.55491924285889 7.928049087524414 C 10.55491924285889 9.841658592224121 10.02398872375488 11.61035919189453 9.059948921203613 12.90834903717041 C 8.169399261474609 14.10737895965576 7.003649234771729 14.76771926879883 5.777459144592285 14.76771926879883 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.777459144592285 1.3583984375 C 3.711899280548096 1.3583984375 3.05890941619873 2.121378898620605 2.692568778991699 2.867738723754883 C 2.08389949798584 4.107789039611816 1.999999046325684 6.032669067382812 1.999999046325684 7.928049087524414 C 1.999999046325684 9.628378868103027 2.460888862609863 11.18532943725586 3.297769546508789 12.31209850311279 C 4.238439083099365 13.57860851287842 5.255139350891113 13.76771926879883 5.777459144592285 13.76771926879883 C 6.99432897567749 13.76771926879883 7.853379249572754 12.85572910308838 8.257148742675781 12.31209850311279 C 9.094029426574707 11.18532943725586 9.554919242858887 9.628378868103027 9.554919242858887 7.928049087524414 C 9.554919242858887 6.032669067382812 9.47101879119873 4.107789039611816 8.862348556518555 2.867738723754883 C 8.49600887298584 2.121378898620605 7.843019485473633 1.3583984375 5.777459144592285 1.3583984375 M 5.777459144592285 -0.6416015625 C 11.08825874328613 -0.6416015625 11.55491924285889 3.510108947753906 11.55491924285889 7.928049087524414 C 11.55491924285889 12.34597873687744 8.968258857727051 15.76771926879883 5.777459144592285 15.76771926879883 C 2.58665943145752 15.76771926879883 -9.5367431640625e-07 12.34597873687744 -9.5367431640625e-07 7.928049087524414 C -9.5367431640625e-07 3.510108947753906 0.4666595458984375 -0.6416015625 5.777459144592285 -0.6416015625 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.559,17.379h0a4.976,4.976,0,0,0,4.151-2.411c1.723-2.685,2.06-5.332,2.06-8.669,0,0-.16-5.979-6.2-5.979",
    transform: "translate(1.322 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.371,17.379h0a4.976,4.976,0,0,1-4.151-2.411C6.5,12.284,6.159,9.636,6.159,6.3c0,0,.161-5.979,6.2-5.979",
    transform: "translate(0.511 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.34,14.08c0,.2,0,.4-.012.58a3.608,3.608,0,0,1-2.813,3.263l-3.03.76A4.811,4.811,0,0,0,1.33,21.7a4.971,4.971,0,0,0-.258,1.15L.361,29H9.706",
    transform: "translate(-0.361 1.974)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,14.08c0,.2,0,.4.012.58a3.608,3.608,0,0,0,2.813,3.263l3.03.76A4.811,4.811,0,0,1,23.1,21.7a4.971,4.971,0,0,1,.258,1.15L24.067,29H15.061",
    transform: "translate(1.702 1.974)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.146 19.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.825,18.664l1.55,8.827-2.821,3.224",
    transform: "translate(-8.732 -16.895)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.456,18.664l-1.55,8.827,2.821,3.224",
    transform: "translate(-8.907 -16.895)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.753,16.849,11.553,18l-2.2-1.151",
    transform: "translate(-8.732 -16.849)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,24.676l-.358,2.069,1.347,1.561,1.347-1.561-.358-2.069a2.541,2.541,0,0,1-1.978,0",
    transform: "translate(-8.822 -16.825)",
    fill: "url(#b)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.636 15.97)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.316 0.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.053 1.086)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.777459144592285 14.76771926879883 C 4.551269054412842 14.76771926879883 3.385519027709961 14.10737895965576 2.494969129562378 12.90834903717041 C 1.530929088592529 11.61035919189453 0.9999991655349731 9.841658592224121 0.9999991655349731 7.928049087524414 C 0.9999991655349731 5.912068843841553 1.096299171447754 3.850348949432373 1.794869184494019 2.42711877822876 C 2.230769157409668 1.539048910140991 3.117859125137329 0.3583988547325134 5.777459144592285 0.3583988547325134 C 8.43705940246582 0.3583988547325134 9.324149131774902 1.539048910140991 9.760048866271973 2.42711877822876 C 10.45861911773682 3.850348949432373 10.55491924285889 5.912068843841553 10.55491924285889 7.928049087524414 C 10.55491924285889 9.841658592224121 10.02398872375488 11.61035919189453 9.059948921203613 12.90834903717041 C 8.169399261474609 14.10737895965576 7.003649234771729 14.76771926879883 5.777459144592285 14.76771926879883 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.777459144592285 1.3583984375 C 3.711899280548096 1.3583984375 3.05890941619873 2.121378898620605 2.692568778991699 2.867738723754883 C 2.08389949798584 4.107789039611816 1.999999046325684 6.032669067382812 1.999999046325684 7.928049087524414 C 1.999999046325684 9.628378868103027 2.460888862609863 11.18532943725586 3.297769546508789 12.31209850311279 C 4.238439083099365 13.57860851287842 5.255139350891113 13.76771926879883 5.777459144592285 13.76771926879883 C 6.99432897567749 13.76771926879883 7.853379249572754 12.85572910308838 8.257148742675781 12.31209850311279 C 9.094029426574707 11.18532943725586 9.554919242858887 9.628378868103027 9.554919242858887 7.928049087524414 C 9.554919242858887 6.032669067382812 9.47101879119873 4.107789039611816 8.862348556518555 2.867738723754883 C 8.49600887298584 2.121378898620605 7.843019485473633 1.3583984375 5.777459144592285 1.3583984375 M 5.777459144592285 -0.6416015625 C 11.08825874328613 -0.6416015625 11.55491924285889 3.510108947753906 11.55491924285889 7.928049087524414 C 11.55491924285889 12.34597873687744 8.968258857727051 15.76771926879883 5.777459144592285 15.76771926879883 C 2.58665943145752 15.76771926879883 -9.5367431640625e-07 12.34597873687744 -9.5367431640625e-07 7.928049087524414 C -9.5367431640625e-07 3.510108947753906 0.4666595458984375 -0.6416015625 5.777459144592285 -0.6416015625 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.559,17.379h0a4.976,4.976,0,0,0,4.151-2.411c1.723-2.685,2.06-5.332,2.06-8.669,0,0-.16-5.979-6.2-5.979",
    transform: "translate(1.322 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.371,17.379h0a4.976,4.976,0,0,1-4.151-2.411C6.5,12.284,6.159,9.636,6.159,6.3c0,0,.161-5.979,6.2-5.979",
    transform: "translate(0.511 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.34,14.08c0,.2,0,.4-.012.58a3.608,3.608,0,0,1-2.813,3.263l-3.03.76A4.811,4.811,0,0,0,1.33,21.7a4.971,4.971,0,0,0-.258,1.15L.361,29H10.967",
    transform: "translate(-0.361 1.974)",
    fill: "#f5f7ff",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,14.08c0,.2,0,.4.012.58a3.608,3.608,0,0,0,2.813,3.263l3.03.76A4.811,4.811,0,0,1,23.1,21.7a4.971,4.971,0,0,1,.258,1.15L24.067,29H13.659",
    transform: "translate(1.702 1.974)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.015 35.686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.825,18.664l1.55,8.827-2.821,3.224",
    transform: "translate(-8.732 -16.895)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.456,18.664l-1.55,8.827,2.821,3.224",
    transform: "translate(-8.907 -16.895)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.753,16.849,11.553,18l-2.2-1.151",
    transform: "translate(-8.732 -16.849)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,24.676l-.358,2.069,1.347,1.561,1.347-1.561-.358-2.069a2.541,2.541,0,0,1-1.978,0",
    transform: "translate(-8.822 -16.825)",
    fill: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizPartnership);
export default __webpack_public_path__ + "static/media/biz-partnership.5068bb70d344b69fc7d0792e72584c7f.svg";
export { ForwardRef as ReactComponent };